// extracted by mini-css-extract-plugin
module.exports = {"image":"image_component_image__jdlTl","caption":"image_component_caption__d6D5Z","popupTitle":"image_component_popupTitle__byd_H"};